<template lang="">
  <div>
    <v-row class="mt-3">
      <!-- fecha -->
      <v-col>
        <v-menu
          ref="pickerFecha"
          v-model="pickerFecha"
          :close-on-content-click="false"
          :return-value.sync="fecha"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="fecha"
              :label="labelFecha"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="fecha"
            no-title
            scrollable
            first-day-of-week="1"
            @input="$refs.pickerFecha.save(fecha)"
          >
            <!-- <v-spacer></v-spacer>
                <v-btn text color="primary" @click="pickerFecha = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.pickerFecha.save(fecha);guardarFecha=true "
                >
                  OK
                </v-btn> -->
          </v-date-picker>
        </v-menu>
      </v-col>
      <!-- hora  -->
      <v-col>
        <v-menu
          ref="pickerHora"
          v-model="pickerHora"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="hora"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="hora"
              :label="labelHora"
              prepend-icon="mdi-clock-time-four-outline"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="pickerHora"
            format="24hr"
            v-model="hora"
            full-width
            @click:minute="$refs.pickerHora.save(hora)"
          ></v-time-picker>
        </v-menu>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  props: {
    labelFecha: String,
    labelHora: String,
    tipo: Number,
  },
  data() {
    return {
      pickerFecha: false,
      pickerHora: false,
      fecha: "",
      hora: "",
    };
  },
  mounted() {
    const today = new Date();
    // const yesterday = new Date();
    // yesterday.setDate(today.getDate() - 1);
    this.hora = `00:00`;
    if (this.tipo == 1) {
      //si es el inicio, por defecto se pondra el primer dia del mes, si no la fecha de hoy

      this.fecha = `${today.getFullYear()}-${this.padZero(
        today.getMonth() + 1
      )}-${this.padZero(today.getDate())}`;
      this.setFechaInicio(this.fecha + " " + this.hora);
    } else {
      today.setDate(today.getDate() + 1);
      this.fecha = `${today.getFullYear()}-${this.padZero(
        today.getMonth() + 1
      )}-${this.padZero(today.getDate())}`;
      this.setFechaFin(this.fecha + " " + this.hora);
    }
  },
  methods: {
    ...mapActions(["setFechaInicio", "setFechaFin"]),
    padZero(value) {
      return value < 10 ? `0${value}` : value;
    },
  },
  watch: {
    pickerFecha() {
      if (this.fecha.length > 0 && this.hora.length > 0) {
        if (this.tipo == 1) {
          this.setFechaInicio(this.fecha + " " + this.hora);
        } else {
          this.setFechaFin(this.fecha + " " + this.hora);
        }
      }
    },
    pickerHora() {
      if (!this.pickerHora && this.fecha.length > 0 && this.hora.length > 0) {
        if (this.tipo == 1) {
          this.setFechaInicio(this.fecha + " " + this.hora);
        } else {
          this.setFechaFin(this.fecha + " " + this.hora);
        }
      }
    },
  },
};
</script>
